module.exports = __webpack_public_path__ + "85afc046393930ddf9235fe169fbe7ca.svg";